import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {PagesService} from '../../shared/services/pages.service';
import {SEOService} from '../../shared/services/seo.service';
import {CmsService} from '../../cms/services/cms.service';

@Component({
  selector: 'app-privacy-page',
  templateUrl: './privacy-page.component.html',
  styleUrls: ['./privacy-page.component.scss']
})
export class PrivacyPageComponent implements OnInit, OnDestroy {

  constructor(private _pagesService: PagesService,
              private _seoService: SEOService,
              private _cmsService: CmsService) {
  }

  private unsubscribe$ = new Subject<any>();

  isWtgNetworkSite: boolean = false; // sito network WTG
  hasPrivacyLoaded: boolean = false;
  
  privacy$: Observable<string>;

  ngOnInit(): void {
    this._seoService.setTitle('Privacy Policy');
    this._cmsService.siteUrl$.pipe(takeUntil(this.unsubscribe$)).subscribe(siteUrl => {
      if (siteUrl) {
        if (siteUrl.includes('vacanzewelcometravel.it')) {
          // imposto il booleano che controlla se si tratta del sito wtg istituzionale (vacanzewelcometravel.it)
          this.isWtgNetworkSite = true;

          // carico subito la privacy WTG
          // NB: WTSud è stata incorporata in WTG dunque, non occorre più mostrare anche la privacy WTSud
          this.privacy$ = this._pagesService.getPrivacy('vacanzewelcometravel.it', 'wtg');
          this.hasPrivacyLoaded = true;
        } else {
          // se non si tratta del sito wtg istituzionale (vacanzewelcometravel.it), carico subito la privacy dedicata del sito attualmente mostrato
          this.loadOtherPrivacy(siteUrl);
        }
      }
    });
  }

  private loadOtherPrivacy(siteUrl: string = ''): void {
    this.privacy$ = this._pagesService.getPrivacy(siteUrl);
    this.hasPrivacyLoaded = true;
  }
  
  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

}
